const columns = [
  { name: 'title', title: 'Titel' },
  { name: 'is_default', title: 'Standard' },
];
export default columns;
